// Generated types for PDMSupplyChainCriteria
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { Priority, RequirementStatus, SupplyChainCriteriaType } from '../../shared/enums';

import { RequirementDefinitionReadAPI, RequirementDefinitionWriteAPI } from '../../sysml/types/requirementdefinition';
import { RequirementDefinitionReadAPISchemaObject, RequirementDefinitionWriteAPISchemaObject } from '../../sysml/types/requirementdefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PDMSupplyChainCriteriaReadAPI extends RequirementDefinitionReadAPI {
  /** Supply chain criteria type classification */
  type?: SupplyChainCriteriaType;
  /** Priority level */
  priority?: Priority;
  /** The current status of the requirement. Each possible status is explained below:
            - "OK": the criterion is fine
            - "TBA": the criterion is to be anlayzed.
            - "ERROR": a criterion with a value that is clearly incoherent, logically impossible.
            - "WARNING": a criterion whose value appears unusual or questionable, but not impossible.
         */
  status?: RequirementStatus | null;
  /** Information about why the criterion is needed or the reasoning and assumptions behind the suggested values */
  analysis?: string | null;
  /** list of informative suggested possible values for the criterion */
  suggestions?: string[] | null;
}

export interface PDMSupplyChainCriteriaWriteAPI extends RequirementDefinitionWriteAPI {
  /** Supply chain criteria type classification */
  type?: SupplyChainCriteriaType;
  /** Priority level */
  priority?: Priority;
  /** The current status of the requirement. Each possible status is explained below:
            - "OK": the criterion is fine
            - "TBA": the criterion is to be anlayzed.
            - "ERROR": a criterion with a value that is clearly incoherent, logically impossible.
            - "WARNING": a criterion whose value appears unusual or questionable, but not impossible.
         */
  status?: RequirementStatus | null;
  /** Information about why the criterion is needed or the reasoning and assumptions behind the suggested values */
  analysis?: string | null;
  /** list of informative suggested possible values for the criterion */
  suggestions?: string[] | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PDMSupplyChainCriteriaReadAPISchema: z.ZodType<PDMSupplyChainCriteriaReadAPI> = RequirementDefinitionReadAPISchemaObject.extend({
  type: z.nativeEnum(SupplyChainCriteriaType).optional(),
  priority: z.nativeEnum(Priority).optional(),
  status: z.nativeEnum(RequirementStatus).nullable().optional(),
  analysis: z.string().nullable().optional(),
  suggestions: z.array(z.string()).nullable().optional(),
}).passthrough();

export const PDMSupplyChainCriteriaWriteAPISchema: z.ZodType<PDMSupplyChainCriteriaWriteAPI> = RequirementDefinitionWriteAPISchemaObject.extend({
  type: z.nativeEnum(SupplyChainCriteriaType).optional(),
  priority: z.nativeEnum(Priority).optional(),
  status: z.nativeEnum(RequirementStatus).nullable().optional(),
  analysis: z.string().nullable().optional(),
  suggestions: z.array(z.string()).nullable().optional(),
}).passthrough();
